import {
  NAMED_CANVAS_PRESET_DIMENSIONS,
  PROJECT_DOCUMENT_VERSION,
  type ProjectDocumentV2,
} from './ProjectDocument.js'

export const DEFAULT_PROJECT_SEED = 0x4e_41_53_51

export function createDefaultProjectDocument(): ProjectDocumentV2 {
  return {
    version: PROJECT_DOCUMENT_VERSION,
    seed: DEFAULT_PROJECT_SEED,
    text: {
      content: 'بسم الله',
      activeFont: 'Nastaliq',
      fontSize: 120,
      lineHeight: 2,
      wordSpacing: 0.25,
      textAlign: 'right',
      baseline: 'middle',
    },
    particles: {
      shape: 'x',
      // Sampling spacing + particle size; lower keeps detailed calligraphy
      // readable instead of under-sampling it into sparse, jumbled chunks.
      density: 4,
      scale: 1,
      customSvg: null,
    },
    appearance: {
      color: { r: 18, g: 18, b: 18 },
      chaosColor: { r: 26, g: 26, b: 46 },
      fadeInChaos: true,
      gridMode: false,
      colorTransitionStart: 0,
      colorTransitionEnd: 1,
      showBackground: true,
      backgroundColor: { r: 255, g: 255, b: 255 },
      showBorder: false,
      borderIntensity: 0.5,
      borderColor: { r: 255, g: 255, b: 255 },
      borderRadius: 0.08,
      borderOnTop: false,
      borderScale: 1.15,
      showGlow: false,
      glowIntensity: 0.5,
      glowColor: { r: 232, g: 213, b: 183 },
      glowSoftness: 24,
    },
    animation: {
      type: 'linear',
      speed: 1,
      easingType: 'smooth',
      easingAmount: 0.5,
      customEasingCurve: {
        p1: { x: 0.25, y: 0.1 },
        p2: { x: 0.25, y: 1 },
      },
      playbackDirection: 'pingPong',
      holdAtOrder: 0,
      holdAtChaos: 0,
      loopMode: 'loop',
      wiggleEnabled: true,
      wiggleSpeed: 0.5,
      wiggleForce: 1,
      wiggleDampening: 0.95,
      rotationEnabled: true,
      rotationSpeed: 0.5,
      motionBlur: 0.65,
    },
    layout: {
      wordOffsets: [],
      letterOffsets: [],
      dotOffsets: [],
      letterMode: false,
      dotMode: false,
    },
    canvas: {
      ...NAMED_CANVAS_PRESET_DIMENSIONS['1920x1080'],
      preset: '1920x1080',
      preferredRenderer: 'webgl2',
    },
  }
}
